import { parseTemporal, temporalFromDate } from '@/shared/utils/temporal';

export const parseTimeValue = (value: string | Date | null | undefined): Date | null => {
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    const time = parseTemporal(value, 'time');
    if (!time) return null;
    const [hours, minutes, seconds] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);
    return date;
};

export const formatTimeValue = (value: Date | null) =>
    value && !Number.isNaN(value.getTime()) ? temporalFromDate(value, 'time') : null;
